import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, LinkedinIcon, Loader2Icon } from 'lucide-react';
import { Logo } from './Logo';
import { navLinks, contactInfo } from '../../data/navigation';
import { services } from '../../data/services';
import { EASE_OUT } from '../../utils/motion';
type NewsletterStatus = 'idle' | 'loading' | 'success' | 'error';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<NewsletterStatus>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus('error');
      return;
    }
    setStatus('loading');
    window.setTimeout(() => {
      setStatus('success');
      setEmail('');
    }, 900);
  };
  return <footer className="bg-ink text-white" data-id="element-305" data-mp="3942s2ayqiaqj">
      <div className="mx-auto max-w-[1440px] px-5 pb-8 pt-20 sm:px-8" data-id="element-306" data-mp="39541yc40kr6o">
        <div className="grid gap-14 lg:grid-cols-12" data-id="element-307" data-mp="2kcl7dk3tv61g">
          <div className="lg:col-span-5" data-id="element-308" data-mp="2kb0avoxydd0y">
            <Logo data-id="element-309" data-mp="2p4cu1jjv4rmb" />
            <p className="mt-6 max-w-md leading-relaxed text-white/65" data-id="element-310" data-mp="2p4uyv4klce5u">
              Conseil en achats et supply chain pour les PME et ETI. Plus de 20 ans d’expérience pour réduire vos
              coûts, fiabiliser vos approvisionnements et structurer votre fonction achats.
            </p>

            <form onSubmit={handleSubmit} className="mt-10 max-w-md" noValidate data-id="element-311" data-mp="3425d2lomby59">
              <label htmlFor="newsletter" className="text-sm font-medium text-white" data-id="element-312" data-mp="38379kur5hw3j">
                La lettre achats & supply chain
              </label>
              <p className="mt-1 text-sm text-white/55" data-id="element-313" data-mp="2u50l2583d8gj">Un article de fond par mois. Pas de spam.</p>
              <div className="mt-4 flex gap-2 rounded-xl bg-white/[0.07] p-1.5 ring-1 ring-inset ring-white/10 focus-within:ring-brass" data-id="element-314" data-mp="2z43rnu3pzmqm">
                <input id="newsletter" type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                if (status !== 'idle') setStatus('idle');
              }} placeholder="votre@email.fr" aria-invalid={status === 'error'} aria-describedby="newsletter-status" className="min-w-0 flex-1 bg-transparent px-3 text-[15px] text-white placeholder:text-white/40 focus:outline-none" data-id="element-315" data-mp="1nndji5fqkkud" />
                <button type="submit" disabled={status === 'loading'} className="flex h-10 items-center gap-2 whitespace-nowrap rounded-lg bg-brass px-4 text-sm font-medium text-ink transition-colors duration-150 hover:bg-[#d6b46e] disabled:opacity-70" data-id="element-316" data-mp="fveyeb7t0jrb">
                  {status === 'loading' ? <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-317" data-mp="2658edfjkul13" /> : status === 'success' ? <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-318" data-mp="28sitx5nzk9ic" /> : <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-319" data-mp="2dqka9iu11uq4" />}
                  S’inscrire
                </button>
              </div>
              <p id="newsletter-status" role="status" className="mt-2 min-h-[20px] text-sm" data-id="element-320" data-mp="2ik6f4oty8ubd">
                {status === 'error' && <span className="text-[#F2A7A0]" data-id="element-321" data-mp="1ptem2086kls9">Merci d’indiquer une adresse email valide.</span>}
                {status === 'success' && <span className="text-brass" data-id="element-322" data-mp="1urg6aohcer5b">Merci ! Votre inscription est confirmée.</span>}
              </p>
            </form>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-7" data-id="element-323" data-mp="1ztf99x967m1q">
            <div data-id="element-324" data-mp="23uhb8luh2c7e">
              <h2 className="text-sm font-medium text-white/50" data-id="element-325" data-mp="23qteldtqd9og">Navigation</h2>
              <ul className="mt-5 space-y-3" data-id="element-326" data-mp="3b5y6d75z1f5r">
                {navLinks.map(l => <li key={l.to} data-id="element-327" data-mp="3f6rtvzfi4ry4">
                    <Link to={l.to} className="text-white/80 transition-colors duration-150 hover:text-white" data-id="element-328" data-mp="3fa5v34cfiv3z">
                      {l.label}
                    </Link>
                  </li>)}
                <li data-id="element-329" data-mp="38u725vth75km">
                  <Link to="/contact" className="text-white/80 transition-colors duration-150 hover:text-white" data-id="element-330" data-mp="3npmspquukjc9">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div data-id="element-331" data-mp="jccbx3j4q0f">
              <h2 className="text-sm font-medium text-white/50" data-id="element-332" data-mp="it5pcjbxo1p">Services</h2>
              <ul className="mt-5 space-y-3" data-id="element-333" data-mp="3rpnig7necgym">
                {services.map(s => <li key={s.slug} data-id="element-334" data-mp="aagpqsdk42t5">
                    <Link to={`/services#${s.slug}`} className="text-white/80 transition-colors duration-150 hover:text-white" data-id="element-335" data-mp="a9nno4pjm1hc">
                      {s.title}
                    </Link>
                  </li>)}
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1" data-id="element-336" data-mp="f7gw74ebj7ks">
              <h2 className="text-sm font-medium text-white/50" data-id="element-337" data-mp="xyvogm7xmj7v">Contact</h2>
              <ul className="mt-5 space-y-3 text-white/80" data-id="element-338" data-mp="12wx8pah3gokx">
                <li data-id="element-339" data-mp="12ub2pf9uqh4t">
                  <a href={`mailto:${contactInfo.email}`} className="break-all transition-colors duration-150 hover:text-white" data-id="element-340" data-mp="ox5x1ge1vka3">
                    {contactInfo.email}
                  </a>
                </li>
                <li data-id="element-341" data-mp="f6kujhv99vlw">
                  <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="transition-colors duration-150 hover:text-white" data-id="element-342" data-mp="f6azhfvcsy9c">
                    {contactInfo.phone}
                  </a>
                </li>
                <li data-id="element-343" data-mp="67za1h6846ih">{contactInfo.location}</li>
                <li data-id="element-344" data-mp="a7q9085wlsy3">
                  <a href={contactInfo.linkedin} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-lg bg-white/10 px-3 py-2 text-sm transition-colors duration-150 hover:bg-white/20" data-id="element-345" data-mp="a91eccezz8rb">
                    <LinkedinIcon className="h-4 w-4" aria-hidden="true" data-id="element-346" data-mp="22xah2bw9ex1d" /> LinkedIn
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-20 overflow-hidden" aria-hidden="true" data-id="element-347" data-mp="1u58ikj5r3qtq">
          <motion.p initial={{
          y: '60%',
          opacity: 0
        }} whileInView={{
          y: '0%',
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: EASE_OUT
        }} className="select-none whitespace-nowrap text-[17vw] font-semibold leading-[0.82] tracking-[-0.05em] text-white/[0.07] xl:text-[15rem]" data-id="element-348" data-mp="1p5cfqn8si5fr">
            L Procure
          </motion.p>
        </div>

        <div className="mt-8 flex flex-col gap-4 border-t border-white/10 pt-6 text-sm text-white/50 sm:flex-row sm:items-center sm:justify-between" data-id="element-349" data-mp="27uis7sizq0t4">
          <p data-id="element-350" data-mp="wgewohwr84ly">© 2026 L Procure Consulting. Tous droits réservés.</p>
          <div className="flex gap-6" data-id="element-351" data-mp="weu4v01tqzrs">
            <Link to="/contact" className="hover:text-white" data-id="element-352" data-mp="mchyd450j9vn">Mentions légales</Link>
            <Link to="/contact" className="hover:text-white" data-id="element-353" data-mp="mang5xl4lvv9">Confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>;
}